// Temporary FormContextProvider while we wait for the new API endpoints

import { createContext, useContext, useState } from "react";

import {
  SurveyConfiguration,
  SurveyModel,
  SurveyVersionOverview,
} from "@rubi/api-generated";

const FormContext = createContext<{
  surveyConfigs: SurveyConfiguration[];
  setSurveyConfigs: (surveyConfigs: SurveyConfiguration[]) => void;
  draftSurveys: SurveyModel[];
  setDraftSurveys: (draftSurveys: SurveyModel[]) => void;
  surveysWithActiveVersions: SurveyVersionOverview[];
  setSurveysWithActiveVersions: (surveys: SurveyVersionOverview[]) => void;
}>(
  {} as {
    surveyConfigs: SurveyConfiguration[];
    setSurveyConfigs: (surveyConfigs: SurveyConfiguration[]) => void;
    draftSurveys: SurveyModel[];
    setDraftSurveys: (draftSurveys: SurveyModel[]) => void;
    surveysWithActiveVersions: SurveyVersionOverview[];
    setSurveysWithActiveVersions: (surveys: SurveyVersionOverview[]) => void;
  },
);

export const FormContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [surveyConfigs, setSurveyConfigs] = useState<SurveyConfiguration[]>([]);
  const [draftSurveys, setDraftSurveys] = useState<SurveyModel[]>([]);
  const [surveysWithActiveVersions, setSurveysWithActiveVersions] = useState<
    SurveyVersionOverview[]
  >([]);

  return (
    <FormContext.Provider
      value={{
        surveyConfigs,
        setSurveyConfigs,
        draftSurveys,
        setDraftSurveys,
        surveysWithActiveVersions,
        setSurveysWithActiveVersions,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};

export const useFormBuilderContext = () => useContext(FormContext);
